window.signupApp = angular.module("cerego.signup", [
  "cerego.common"
])

# replace these with explicit import
req = require.context('./signup/resources', false, /\.js$/)
req.keys().forEach(req)
req = require.context('./signup/controllers', false, /\.js$/)
req.keys().forEach(req)
